<script>
import {ref, inject, toRef, computed, nextTick, watch, onMounted} from "vue";
import { useStore } from "vuex";
import {tableColResize} from '@/tools/table-drag';
import sortablejs from 'sortablejs';
import {getRandomString,isNotEmpty} from "../../../tools/utils";
import {saveMyColums} from "../../../tools/table-drag";
export default {
  name: "purchase-order",
  props: ["tableSet"],
  setup(props, context) {
    const store = useStore();
    const filter = ref("");
    const myRef = ref(null);
    let pasteRow = ref(null); //粘贴行位置
    let pasteCol = ref(null); //粘贴列位置
    let tableSet = toRef(props.tableSet);
    let tableClassName = ref('table_'+getRandomString());
    function isNotEmptyFun(value){
      return isNotEmpty(value);
    }
    function startResize(event,props){
      let callBack = (columns)=>{
        saveColsConfig();
      }
      tableColResize(event,props,tableSet.value.columns,callBack);
    }
    function isValueEmpty(value){
      return !isNotEmpty(value);
    }
    //设置isFullscreen属性
    tableSet.value.isFullscreen ? tableSet.value.isFullscreen = true : tableSet.value.isFullscreen = false
    // if (!tableSet.value) {
    //   tableSet = computed(() => {
    //     return inject("tableSet");
    //   });
    // }
    let source_pages = computed(() => {
      let tot = tableSet.value.pagination.rowsNumber
          ? tableSet.value.pagination.rowsNumber
          : 0;
      let rowpage = parseInt(tableSet.value.pagination.rowsPerPage);
      let pages = parseInt((tot - 1 + rowpage) / rowpage);
      return pages;
    });
    let dense = ref(false);
    let visibleColumns = ref([]);
    let showColumns = computed(() => {
      if (tableSet.value.columns && tableSet.value.columns.length > 0) {
        let show = [];
        if (!tableSet.value.tableName) {
          console.log('ERROR://请设置tableName');
          console.log('+++tableSet.value = ',tableSet.value)
        }
        tableSet.value.columns.forEach((it) => {
          show.push({ check: isNotEmpty(it.check) ? it.check : true, name: it.name, label: it.label });
        });
        return show;
      } else {
        return [];
      }
    });
    selectCol();
    const tableStyle = computed(() => {
      if (!tableSet.value.isFullscreen) {
        let dic = {}
        if (tableSet.value.height) {
          dic['height'] = tableSet.value.height
        }
        if (tableSet.value.maxHeight) {
          dic['max-height'] = tableSet.value.maxHeight
        }
        return dic;
      }
      return {};
    });
    function toggleFullscreen() {
      tableSet.value.isFullscreen = !tableSet.value.isFullscreen;
    }
    function selectCol(name = null) {
      visibleColumns.value = [];
      //判断是否可见
      //如果可见，就设置为不可见
      //如果不可见，就设置为可见
      if (name) {
        showColumns.value.forEach((it) => {
          if (it.name === name) {
            it.check = !it.check;
          }
          if (it.check) {
            visibleColumns.value.push(it.name);
          }
        });
        tableSet.value.columns.forEach((it) => {
          if (it.name === name) {
            it.check = isNotEmpty(it.check)? !it.check : false;
          }
        });
        saveColsConfig();
      } else {
        showColumns.value.forEach((it) => {
          if (it.check) {
            visibleColumns.value.push(it.name);
          }
        });
      }
    }
    let saveColsConfig = ()=>{
      if(isNotEmpty(tableSet.value.tableName)){
        let userBase = JSON.parse(localStorage.getItem('userBase'));
        let pageUserConfig = localStorage.getItem(tableSet.value.tableName+'-'+userBase.id);
        pageUserConfig = isNotEmpty(pageUserConfig) ? JSON.parse(pageUserConfig) : {id:''};
        saveMyColums({name:tableSet.value.tableName,id:pageUserConfig.id,colums:tableSet.value.columns});
      }
    }
    function tool_click(item) {
      let params = JSON.parse(JSON.stringify(item));
      params.tableSet = tableSet.value;
      context.emit("tool_click", params);
    }
    /** unpem 为 true 时隐藏；无该字段或为 false 时显示 */
    function showToolBtn(item) {
      return item && item.unpem !== true;
    }
    function handleClick(props) {
      if (tableSet.value.rowkey === 'fId') {
        props.key = props.pageIndex + 1
      }
      pasteRow.value = props.rowIndex;
      pasteCol.value = props.col.name;
      // 排他思想,所有的都置为false,点谁再给谁赋值
      tableSet.value.data.map((item) => {
        item.rowKey = null;
      });
      props.row.rowKey = props.rowIndex;
      props.row.colKey = props.col.name;
      if (props.col.edit) {
        nextTick(() => {
          myRef.value.focus();
        });
      }
    }
    function onBlur() {
      tableSet.value.data.map((item) => {
        item.rowKey = null;
        item.colKey = null;
      });
    }
    function rowClick(e, row) {
      if (tableSet.value.selection && tableSet.value.selection == 'single') {
        tableSet.value.selected = []
        tableSet.value.selected.push(row)
        context.emit("selectionRow", {added:true,rows:tableSet.value.selected})
      }
      if (tableSet.value.selection && tableSet.value.selection == 'multiple') {
        let isHasNowRow = tableSet.value.selected.some(item=>{
          return item[tableSet.value['row_key']] == row[tableSet.value['row_key']]
        });
        if(isHasNowRow){
          tableSet.value.selected = tableSet.value.selected.filter(item=>{
            return item[tableSet.value['row_key']] != row[tableSet.value['row_key']];
          })
        }else{
          tableSet.value.selected.push(row)
        }
      }
      context.emit("rowClick", row);
    }
    function handledbClick(e, row) {
      context.emit("handledbClick", e, row);
    }
    function pasteInfo(e) {
      try {
        var data = null;
        var clipboardData = e.clipboardData;
        //复制过来的内容
        data = clipboardData.getData("Text");
        var rowStrArray = data.split("\n"); //根据换行拆分成数组
        //复制的数据转成数组,存起来
        let rowsInfo = [];
        for (var i = 0; i < rowStrArray.length; i++) {
          var row = [];
          var tdStrArray = rowStrArray[i].split("\t"); //按列拆分
          for (var j = 0; j < tdStrArray.length; j++) {
            row.push(tdStrArray[j]);
          }
          rowsInfo.push(row);
        }
        let list = [];
        if (rowsInfo.length) {
          //复制的数据二维数组转成一维数组
          list = rowsInfo.reduce((total, currentValue) => {
            return total.concat(currentValue);
          });
        } else {
          //粘贴单个
          list = rowStrArray;
        }
        //存储粘贴后的数组
        const arr = [];
        //粘贴的数组 比 要替换的数组短的时候
        tableSet.value.data.map((item, index) => {
          list.map((ite, idx) => {
            if (index == idx + pasteRow.value) {
              arr.push({ ...item, [pasteCol.value]: ite });
            }
          });
        });
        //粘贴的数组比  要替换的数组长的时候
        //list3:从粘贴位置开始,后半截数组
        const list3 = tableSet.value.data.slice(pasteRow.value);
        const list2 = list.slice(list3.length);
        if (list.length > list3.length) {
          //粘贴位置开始 的数组
          list2.map((item, index) => {
            arr.push({
              [pasteCol.value]: item,
              fId:
                  'p_' + (Math.random() + new Date().getTime())
                      .toString(32)
                      .slice(0, 8) + '_' + index,
            });
          });
        }
        arr.forEach((item) => {
          let index = tableSet.value.data.findIndex((e) => e.fId === item.fId);
          if (index > -1) {
            tableSet.value.data[index] = item;
          } else {
            tableSet.value.data.push(item);
          }
        });
      } catch (err) {
        store.dispatch("response/error-tip", {
          message: "请正确复制一列表格数据",
        });
      }
    }

    function tipToArr(tip) {
      return tip.split('\n')
    }
    let default_pagination = ref({
      page: 1,
      rowsPerPage: 1000,
    });
    watch(
        () => tableSet.value.columns,
        () => {
          selectCol();
        }
    );
    watch(
        () => filter.value,
        (v) => {
          let cloneData = JSON.parse(JSON.stringify(tableSet.value.data));

          if (v && v.length) {
            tableSet.value.data = cloneData.map(
                ({ MLFB_rowspan, Quantity_rowspan, ...rest }) => {
                  return { ...rest, MLFB_rowspan: 1, Quantity_rowspan: 1 };
                }
            );
          } else {
            const rows = cloneData;
            function merageByMLFB() {
              let MLFB_rowspan = 1; // 初始 MLFB_rowspan 值
              let startIdx = 0; // 用于记录相同数据的起始索引
              // 遍历数组并设置 MLFB_rowspan 属性
              for (let i = 0; i < rows.length; i++) {
                if (
                    i === rows.length - 1 ||
                    rows[i].MLFB_Sort !== rows[i + 1].MLFB_Sort
                ) {
                  for (let j = startIdx; j <= i; j++) {
                    if (j === startIdx) {
                      rows[j].MLFB_rowspan = MLFB_rowspan;
                    } else {
                      rows[j].MLFB_rowspan = 0;
                    }
                  }
                  MLFB_rowspan = 1; // 重置 MLFB_rowspan 为 1
                  startIdx = i + 1; // 更新起始索引为下一个不同数据的位置
                } else {
                  MLFB_rowspan++; // 如果 id 相等，增加 MLFB_rowspan
                  rows[i].MLFB_rowspan = 0; // 标记当前对象的 MLFB_rowspan 为 0
                }
              }
              return rows;
            }
            merageByMLFB();
            tableSet.value.data = rows;
          }
        },
        { deep: true }
    );

    //设置颜色和背景色
    function fetchColorStyle(row) {
      let style = {}
      if (row.color) {
        style['color'] = row.color
      }
      if (row.bgcolor) {
        style['background-color'] = row.bgcolor
      }
      return style
    }
    let sortableDom = ref(null);
    let tableKey = ref(getRandomString());
    let  setTableSortFun = async()=>{
      nextTick(()=>{
        let myDom = document.getElementsByClassName(tableClassName.value)[0].childNodes[1].children[0].children[0].children[0];
        // let myDom = document.getElementsByClassName(tableClassName.value)[0].children[0].children[0];
        sortableDom.value = sortablejs.create(myDom, {
          ghostClass: 'sortable-ghost',
          animation: 60,
          setData(dataTransfer) {
          },
          onEnd: (e) => {
            let oldIndex = e.oldIndex;
            let newIndex = e.newIndex;
            if(tableSet.value.selection && tableSet.value.showSelection){//打开选择列时需进行处理
              if(oldIndex == 0 || newIndex ==0){
                tableKey.value = getRandomString();
                nextTick(()=>{
                  setTableSortFun();
                })
                return
              }
              oldIndex -=1;
              newIndex-=1;
            }
            let showColumns = tableSet.value.columns.filter((item)=>{//获取显示的列顺序
              return visibleColumns.value.includes(item.name);
            });
            //获取拖拽的列数据 和 目标数据
            let sortDom = showColumns[oldIndex];
            let targeDom = showColumns[newIndex];
            //获取真实数据目标位置的 下标
            let targeDomDataIndex = tableSet.value.columns.findIndex(item=>{
              return item.name == targeDom.name;
            });
            let newRowData = [];
            tableSet.value.columns.forEach((item,index)=>{//在原数据中重新排序
              if(item.name != sortDom.name){
                newRowData.push(item);
              }
              if(oldIndex > newIndex){
               if((targeDomDataIndex-1) == index){
                  newRowData.push(sortDom);
                }
              }else{
                if(targeDomDataIndex == index){
                  newRowData.push(sortDom);
                }
              }
            });
            if(oldIndex > newIndex && targeDomDataIndex == 0){
              newRowData= [sortDom,...newRowData]
            }
            //刷新显示列visibleColumns字段的顺序
            let newvisibleColumns = [];
            newRowData.forEach(item=>{
              if(visibleColumns.value.includes(item.name)){
                newvisibleColumns.push(item.name);
              }
            });
            tableSet.value.columns = newRowData;
            visibleColumns.value = newvisibleColumns;
            tableKey.value = getRandomString();
            saveColsConfig();//保存列数据
            nextTick(()=>{
              setTableSortFun();
            })
          },
        });
      })
    }
    function changeRowsPerPage(value){
      tableSet.value.pagination.rowsPerPage = value;
      context.emit("changePageSize", value);
    }
    function pageChange(value){
      tableSet.value.pagination.page = value;
      context.emit("changePageIndex", value);
    }
    function handleSelection(details){
      context.emit("selectionRow", details);
    }
    let showRowData = computed(()=>{
      if(tableSet?.value?.falsePagination){
        return  paginate(tableSet?.value?.data,tableSet?.value.pagination.rowsPerPage,tableSet?.value.pagination.page)
      }else{
        return tableSet?.value?.data || []
      }
    })
    function paginate(array, pageSize, pageNumber) {
      pageNumber = pageNumber - 1;
      return array.slice(pageSize * pageNumber, pageSize * (pageNumber + 1));
    }
    onMounted(()=>{
      nextTick(()=>{
        setTableSortFun()
      })
    })
    return {
      showRowData,
      changeRowsPerPage,
      handleSelection,
      tableSet,
      default_pagination,
      source_pages,
      dense,
      showColumns,
      visibleColumns,
      selectCol,
      tool_click,
      showToolBtn,
      handleClick,
      onBlur,
      myRef,
      rowClick,
      tableStyle,
      toggleFullscreen,
      handledbClick,
      filter,
      pasteInfo,
      // bomGetRowSpan,
      fetchColorStyle,
      tipToArr,
      startResize,
      tableKey,
      tableClassName,
      pageChange,
      isValueEmpty
    };
  },
};
</script>

<template>
  <div>
    <!-- 可以编辑的表格 不带分页       separator='cell' :dense="dense" :options="[1,2,3,5,10,50]"  :style="{width:props.col.width}"-->
    <q-table :key="tableKey" class="my-sticky-header-table" :class="tableClassName" v-if="tableSet.edit && tableSet.selection" :rows="tableSet.data" :row-key="tableSet.rowkey" square flat
             dense color="primary" virtual-scroll :columns="tableSet.columns" :loading="!tableSet.isFullscreen && tableSet.loading"
             :selection="tableSet.selection" v-model:selected="tableSet.selected" no-data-label="无可用数据" v-model:fullscreen="tableSet.isFullscreen"
             :rows-per-page-options="[1000000]" hide-pagination :visible-columns="visibleColumns" :style="tableStyle"
             :separator='tableSet.separator' @row-click="rowClick" @paste.enter.capture.prevent="pasteInfo($event)" @selection="handleSelection">
      <!-- 表头插槽 可以设置表头样式 必填项标记* -->
      <template v-slot:header-cell="props">
        <q-th :props="props" style="position: relative" class="sort-col">
          <span v-if="props.col.star" style="color:red">*</span>
          {{ props.col.label }}
          <q-icon :class="props.col.icon" style="font-size:16px; color:gray; margin-left: 2px;" v-if="props.col.icon">
            <q-tooltip anchor="top middle" self="bottom middle" v-if="props.col.icontip">
              <div v-for="(tip, index) in tipToArr(props.col.icontip)" :key="index">
                {{ tip }}
                <br v-if="index < props.col.icontip.length - 1">
              </div>
            </q-tooltip>
          </q-icon>
          <div class="my-table-resizer" @click.stop @mousedown.prevent="(evnt)=>startResize(evnt,props)"></div>
        </q-th>
      </template>
      <template v-slot:body-cell="props">
        <q-td :props="props" @click="handleClick(props)">
          <span
              v-if="props.row.rowKey != props.rowIndex || props.row.colKey != props.col.name || !props.col.edit">
              <span v-if="props.col.name == 'matched'">
                  <span v-if="!isValueEmpty(props.value)">
                    <q-icon v-if="props.value" name="fas fa-check-circle"  color="green" size="xs" >
                      <q-tooltip anchor="top middle" self="bottom middle">匹配成功</q-tooltip>
                    </q-icon>
                    <q-icon v-else name="fas fa-times-circle" color="red" size="xs" >
                      <q-tooltip anchor="top middle" self="bottom middle">匹配失败</q-tooltip>
                    </q-icon>
                  </span>
                  <span v-else>
                    <q-icon name="fas fa-times-circle" color="red" size="xs" >
                      <q-tooltip anchor="top middle" self="bottom middle">匹配失败</q-tooltip>
                    </q-icon>
                  </span>
              </span>
              <span v-else>
               {{props.value=='undefined'?'': props.value}}
              </span>
              </span>
          <q-input v-if="props.row.rowKey == props.rowIndex &&props.row.colKey == props.col.name && props.col.edit"
                   :input-class="props.col.class" style="width:auto" v-model="tableSet.data[props.rowIndex][props.col.name]"
                   dense outlined ref='myRef' @blur="onBlur" />

        </q-td>
      </template>
      <!-- 具体单元格插槽 可以设置某个字段的颜色 -->
      <template #body-cell-apiStatus="props">
        <q-td :props="props">
          <q-badge color="green" v-if="props.row.apiStatus == 1">
            成功
          </q-badge>
          <q-badge color="red" v-if="props.row.apiStatus == 0 && props.row.MLFB_Sort && props.row.MLFB_Sort.length>0 && props.row.Qty">
            失败
          </q-badge>
        </q-td>
      </template>
      <!-- 状态开关 -->
      <!-- <template #body-cell-status="props">
        <q-td :props="props">
          {{props.value}}
        </q-td>
      </template> -->
      
      <template v-slot:top="props" v-if="tableSet.tools&&tableSet.tools.show_toolbar">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm" v-if="tableSet.tools.title">{{ tableSet.tools.title }}</span>
          <q-space />
          <div class="q-gutter-sm text-right">
          
            <template v-for="item in tableSet.tools.btns" :key="item.index">
              <q-btn v-if="showToolBtn(item)" rounded flat dense size="md" :icon="item.icon" color="primary"
                     @click="tool_click(item)">
                <q-tooltip anchor="top middle" self="bottom middle" v-if="item.name">{{item.desc? item.desc: item.name[0]}}</q-tooltip>
              </q-btn>
            </template>
            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">
              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"
                          @click="selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <!-- <q-btn rounded flat dense size="md" icon="fas fa-table" color="primary" @click="dense=!dense">
              <q-tooltip>密集表格</q-tooltip>
            </q-btn> -->
            <q-btn rounded color="primary" flat round dense
                   :icon="tableSet.isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" @click="toggleFullscreen()">
              <q-tooltip anchor="top middle" self="bottom middle">{{ tableSet.isFullscreen ? '退出全屏' : '全屏' }}</q-tooltip>
            </q-btn>
          </div>
        </q-toolbar>
      </template>
    </q-table>

    <!-- 有选择框的表格  -->
    <q-table :key="tableKey" :class="tableClassName" v-else-if="tableSet.selection && tableSet.showSelection" :rows="showRowData" :row-key="tableSet.rowkey"
             square flat color="primary" dense class="my-sticky-header-table" virtual-scroll :columns="tableSet.columns"
             :loading="!tableSet.isFullscreen && tableSet.loading" :selection="tableSet.selection" v-model:selected="tableSet.selected"
             no-data-label="无可用数据" v-model:fullscreen="tableSet.isFullscreen" v-model:pagination="default_pagination" hide-pagination :style="tableStyle"
             :separator='tableSet.separator' @row-click="rowClick" :visible-columns="visibleColumns" @selection="handleSelection">
      <!-- 标题栏右侧图标 -->

      <template v-slot:header-cell="props">
        <q-th :props="props" :style="props.col.style ? props.col.style : ''" style="position: relative" class="sort-col">
          {{ props.col.label }}
          <!-- fa fa-info-circle -->
          <q-icon :class="props.col.icon" style="font-size:16px; color:gray;" v-if="props.col.icon">
            <q-tooltip anchor="top middle" self="bottom middle" v-if="props.col.icontip">
              <div v-for="(tip, index) in tipToArr(props.col.icontip)" :key="index">
                {{ tip }}
                <br v-if="index < props.col.icontip.length - 1">
              </div>
            </q-tooltip>
          </q-icon>
          <div class="my-table-resizer" @click.stop @mousedown.prevent="(evnt)=>startResize(evnt,props)"></div>
        </q-th>
      </template>
      <template v-slot:body-cell="props">
        <q-td :props="props" :class="{cellRed:props.col.isValueEmptyRedCell && isValueEmpty(props.value)}">
          <q-icon v-if="typeof(props.value)=='boolean'" :name="props.value?'fas fa-check-circle':''"
                  :class="props.value?'text-positive':''" size="xs" />
          <span v-else>{{ props.value }}</span>
        </q-td>
      </template>
      <template v-slot:top="props" v-if="tableSet.tools&&tableSet.tools.show_toolbar">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm" v-if="tableSet.tools.title">{{ tableSet.tools.title }}</span>
          <q-space />
          <div class="q-gutter-sm text-right">
            <template v-for="item in tableSet.tools.btns" :key="item.index">
              <q-btn v-if="showToolBtn(item)" rounded flat dense size="md" :icon="item.icon" color="primary"
                     @click="tool_click(item)">
                <q-tooltip anchor="top middle" self="bottom middle" v-if="item.name">{{item.desc? item.desc: item.name[0]}}</q-tooltip>
              </q-btn>
            </template>
            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">
              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"
                          @click="selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <!-- <q-btn rounded flat dense size="md" icon="fas fa-table" color="primary" @click="dense=!dense">
              <q-tooltip>密集表格</q-tooltip>
            </q-btn> -->
            <q-btn rounded color="primary" flat round dense
                   :icon="tableSet.isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" @click="toggleFullscreen()">
              <q-tooltip anchor="top middle" self="bottom middle">{{ tableSet.isFullscreen ? '退出全屏' : '全屏' }}</q-tooltip>
            </q-btn>
          </div>
        </q-toolbar>
      </template>

      <!-- bomSource合并的插槽 -->
      <!-- <template #body-cell-MLFB_Sort="props" v-if="tableSet.bomSource">
        <q-td :props="props" v-if="props.row.MLFB_rowspan >1" :rowspan='props.row.MLFB_rowspan'>
          {{props.value}}
        </q-td>
        <q-td :props="props" v-if="props.row.MLFB_rowspan == '1'">
          {{props.value}}
        </q-td>
      </template> -->


      <template v-slot:bottom="scope" v-if="tableSet.pagination.rowsNumber">
        <div class="inline-block">
          <span class="inline-block text-body2">
            每页行数：
          </span>
          <span class="inline-block">
            <q-select v-model="tableSet.pagination.rowsPerPage" @update:model-value="changeRowsPerPage" filled dense options-dense :options="[10,30,50,100]" />
          </span>
        </div>
        <div class="inline-block q-mx-sm items-center">
          <div class="inline-block text-body2">
            数据总行：
          </div>
          <div class="inline-block">
            <q-badge color="primary" align="middle" outline>
              {{tableSet.pagination.rowsNumber}}
            </q-badge>
          </div>
        </div>
        <q-pagination v-model="tableSet.pagination.page" @update:model-value="pageChange" color="primary" :max="source_pages" size="12px"
                      :max-pages="$q.platform.is.mobile?3:5" :boundary-numbers="false" :boundary-links="true"
                      class="float-right my-pagination"> </q-pagination>
      </template>
    </q-table>

    <!-- 假的选中框   因为需要用到选中高亮的效果-->
    <q-table :key="tableKey" :class="tableClassName" v-else :rows="tableSet.data" :row-key="tableSet.rowkey" square flat color="primary"  virtual-scroll dense
             class="my-sticky-header-table my-table" :columns="tableSet.columns" :loading="!tableSet.isFullscreen && tableSet.loading"  no-data-label="无可用数据"
             v-model:fullscreen="tableSet.isFullscreen"
             hide-pagination :visible-columns="visibleColumns" :style="tableStyle" :filter="filter"
             :selection="tableSet.selection" v-model:selected="tableSet.selected"
             :separator='tableSet.separator'  v-model:pagination="default_pagination"
             @row-click="rowClick"  @row-dblclick='handledbClick'>

      <template v-slot:top="props" v-if="tableSet.tools&&tableSet.tools.show_toolbar">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm" v-if="tableSet.tools.title">{{ tableSet.tools.title }}</span>
          <q-space />

          <q-input dense outlined v-model="filter" placeholder="请输入子物料订货号查询" v-if="tableSet.tools.input" />
          <q-space />

          <div class="q-gutter-sm text-right">
            <template v-for="item in tableSet.tools.btns" :key="item.index">
              <q-btn v-if="showToolBtn(item)" rounded flat dense size="md" :icon="item.icon" color="primary"
                     @click="tool_click(item)">
                <q-tooltip anchor="top middle" self="bottom middle" v-if="item.name">{{item.desc? item.desc: item.name[0]}}</q-tooltip>
              </q-btn>
            </template>

            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">
              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"
                          @click="selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <q-btn rounded color="primary" flat round dense
                   :icon="tableSet.isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" @click="toggleFullscreen()">
              <q-tooltip anchor="top middle" self="bottom middle">{{ tableSet.isFullscreen ? '退出全屏' : '全屏' }}</q-tooltip>
            </q-btn>
          </div>
        </q-toolbar>
      </template>
      <!-- 添加颜色和背景颜色 -->
      <template v-slot:body-cell="props">
        <q-td :props="props" :style="{color:props.row.color,background:props.row.bgcolor}" v-if="props.row.color && props.row.bgcolor">
          {{props.value}}
        </q-td>
        <q-td :props="props" :style="{background:props.row.bgcolor}" v-else-if="props.row.bgcolor">
          {{props.value}}
        </q-td>
        <q-td :props="props" :style="{color:props.row.color}" v-else-if="props.row.color">
          {{props.value}}
        </q-td>
        <q-td :props="props" v-else>
          {{props.value}}
        </q-td>
      </template>

      <!-- 表头插槽 可以设置表头样式 必填项标记* -->
      <template v-slot:header="props">
        <q-tr :props="props" class="sort-col">
          <!-- 有选择框时候,占位用,勿删 -->
          <q-th v-if="tableSet.tableName !== 'orderbundleData.BOMtableSet' && tableSet.tableName !== 'orderbundleData.bundletableSet'"></q-th>
          <q-th v-for="col in props.cols" :key="col.name" :props="props" :style="col.style ? col.style : ''">
            <span v-if="col.star" style="color:red">*</span>
            {{ col.label }}
            <q-icon :class="col.icon" style="font-size:16px; color:gray;" v-if="col.icon">
              <q-tooltip anchor="top middle" self="bottom middle" v-if="col.icontip">
                <div v-for="(tip, index) in tipToArr(col.icontip)" :key="index">
                  {{ tip }}
                  <br v-if="index < col.icontip.length - 1">
                </div>
              </q-tooltip>
            </q-icon>
          </q-th>
        </q-tr>
      </template>



      <template #body-cell-MLFB_Sort="props" v-if="tableSet.bom">
        <q-td :props="props" v-if="props.row.MLFB_rowspan >1" :rowspan='props.row.MLFB_rowspan' :style="fetchColorStyle(props.row)">
          {{props.value}}
        </q-td>
        <q-td :props="props" v-if="props.row.MLFB_rowspan == '1'" :style="fetchColorStyle(props.row)" >
          {{props.value}}
        </q-td>
      </template>

      <template #body-cell-MLFB_Sort="props" v-if="tableSet.bundle">
        <q-td :props="props" v-if="props.row.MLFB_rowspan >1" :rowspan='props.row.MLFB_rowspan' :style="fetchColorStyle(props.row)">
          {{props.value}}
        </q-td>
        <q-td :props="props" v-if="props.row.MLFB_rowspan == '1'" :style="fetchColorStyle(props.row)" >
          {{props.value}}
        </q-td>
      </template>

      <template #body-cell-Quantity="props" v-if="tableSet.bundle">
        <q-td :props="props" v-if="props.row.MLFB_rowspan >1" :rowspan='props.row.MLFB_rowspan' :style="fetchColorStyle(props.row)">
          {{props.value}}
        </q-td>
        <q-td :props="props" v-if="props.row.MLFB_rowspan == '1'" :style="fetchColorStyle(props.row)" >
          {{props.value}}
        </q-td>
      </template>

      <template #body-cell-O_LineNo="props" v-if="tableSet.bundle">
        <q-td :props="props" v-if="props.row.MLFB_rowspan >1" :rowspan='props.row.MLFB_rowspan' :style="fetchColorStyle(props.row)">
          {{props.value}}
        </q-td>
        <q-td :props="props" v-if="props.row.MLFB_rowspan == '1'" :style="fetchColorStyle(props.row)" >
          {{props.value}}
        </q-td>
      </template>

      <template v-slot:bottom="scope" v-if="tableSet.pagination.rowsNumber">
        <div class="inline-block">
          <span class="inline-block text-body2">
            每页行数：
          </span>
          <span class="inline-block">
            <q-select v-model="tableSet.pagination.rowsPerPage" @update:model-value="changeRowsPerPage" filled dense options-dense :options="[10,30,50,100]" />
          </span>
        </div>
        <div class="inline-block q-mx-sm items-center">
          <div class="inline-block text-body2">
            数据总行：
          </div>
          <div class="inline-block">
            <q-badge color="primary" align="middle" outline>
              {{tableSet.pagination.rowsNumber}}
            </q-badge>
          </div>
        </div>
        <q-pagination v-model="tableSet.pagination.page" @update:model-value="pageChange" color="primary" :max="source_pages" size="12px" :max-pages="5"
                      :boundary-numbers="false" :boundary-links="true" class="float-right"> </q-pagination>
      </template>
    </q-table>

  </div>

</template>
<style lang='scss'>
.my-sticky-header-table {
  /* height or max-height is important */
  // height: 310px;

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    /* bg color is important for th; just specify one */
    background-color: #fff;
  }

  thead tr {
    position: sticky;
    z-index: 1;
    &:first-child {
      top: 0;
    }
  }

  /* this is when the loading indicator appears */
  &.q-table--loading {
    thead tr:last-child th {
      /* height of all previous header rows */
      top: 48px;
    }
  }

}
.q-table--cell-separator td:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
//表格里的input框从右输入
.rtl-input {
  text-align: right;
}

.my-pagination {
  .q-pagination__middle > .q-btn {
    width: 10px;
    max-width: 10px !important;
  }
}

//隐藏选择框
.my-table {
  tr > td:first-child {
    .q-checkbox{
      display: none;
    }
  }

  tr > th:first-child {
    .q-checkbox{
      display: none;
    }
  }
}
.cellRed{
  background-color: #C10015 !important;
}
</style>

